import { SxProps, Theme } from '@mui/material/styles'
import { hoverBaseStyles } from '../base/hoverBase.styles'

export const introOffersStyles = {
  root: {
    ...hoverBaseStyles.root,
  } as SxProps<Theme>,

  item: {
    color: 'info.main',
    ...hoverBaseStyles.textRegular,
  } as SxProps<Theme>,
}
